import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const ProtectedRoute = ({ children, requirePremium = false }) => {
    const [authData, setAuthData] = useState(null); // Will contain { authenticated, isPremium }
    const [loading, setLoading] = useState(true);

    // console.log('ProtectedRoute: Component mounted, requirePremium =', requirePremium);

    useEffect(() => {
        const checkAuth = async () => {
            // console.log('🔍 ProtectedRoute: Checking authentication...');
            try {
                const res = await fetch(`${API_BASE_URL}/auth/check`, {
                    credentials: "include", // Send cookies (JWT)
                });

                const data = await res.json();
                // console.log('✅ ProtectedRoute: Auth response:', data);
                setAuthData(data);
            } catch (error) {
                console.error("❌ Authentication check failed:", error);
                setAuthData({ authenticated: false, isPremium: false });
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    // console.log('ProtectedRoute: loading =', loading, 'authData =', authData);

    if (loading) {
        // console.log('ProtectedRoute: Showing loading state');
        return <p>Loading...</p>; // Show loading state while checking auth
    }

    // Check if user is authenticated but not verified
    if (authData?.verified === false) {
        // console.log('ProtectedRoute: User not verified, redirecting to /verify');
        return <Navigate to="/verify" />;
    }

    if (!authData?.authenticated) {
        // console.log('ProtectedRoute: Not authenticated, redirecting to /login');
        return <Navigate to="/login" />;
    }

    // Check premium requirement if specified
    if (requirePremium && !authData?.isPremium) {
        // console.log('ProtectedRoute: Not premium, redirecting to /service');
        return <Navigate to="/service" />;
    }

    // console.log('ProtectedRoute: Authenticated and premium check passed, rendering children');
    return children; // Render the protected component if authenticated
};

export default ProtectedRoute;
